__turbopack_context__.v({
  "quizContent": "Mna7NG_quizContent",
  "quizDescription": "Mna7NG_quizDescription",
  "quizEntryPoint": "Mna7NG_quizEntryPoint",
  "quizModal": "Mna7NG_quizModal",
  "selectionContainer": "Mna7NG_selectionContainer",
});
